import React, { RefObject } from 'react';
import { useIntl } from 'gatsby-plugin-intl';

import AvionautLogo from '@assets/svg/avionaut-black.svg';
import { ShopOnlineURL } from '@helpers/shop-online.helper';
import { Switch } from '@components/switch-language';
import { getLink } from '@helpers/linking.helper';
import { PageType } from '@constants/pageType.constants';
import { DropdownOption, SlugAlternative } from '../../../../types/navigation.types';
import { TopBar } from '../../../../types';
import localeHelper from '../../../../../src/helpers/locale.json';
import { useWindowSize } from '../../../../hooks/use-window-size';
import Shop from '@assets/svg/shop.svg';


import s from './DesktopNavigationGrid.module.scss';


interface IDesktopNavigationGrid {
  refWrapper: RefObject<HTMLDivElement>;
  refTopBar: RefObject<HTMLDivElement>;
  refProductNavigation: RefObject<HTMLDivElement>;
  multilingualSlugsForStaticPages: SlugAlternative[];
  multilingualSlugsForCmsArticle: any;
  isTopBarVisible?: boolean;
  isProductSite?: boolean;
  isKnowledgeBase?: boolean;
  topBar?: TopBar;
  productsDropdownOptions: DropdownOption[];
  othersDropdownOptions: DropdownOption[];
  pageType: any;
}

const DesktopNavigationGrid = (props: IDesktopNavigationGrid) => {
  const {
    refWrapper,
    multilingualSlugsForStaticPages,
    isKnowledgeBase,
    multilingualSlugsForCmsArticle,
    pageType,
  } = props;

  const intl = useIntl();
  const windowSize = useWindowSize();


  const homeURL = getLink(intl.locale, PageType.START);
  const contactURL = getLink(intl.locale, PageType.CONTACT);
  const carSeatsURL = getLink(intl.locale, PageType.CAR_SEATS);
  const kbURL = getLink(intl.locale, PageType.KNOWLEDGE_BASE);

  return (
    <div className={`${s.desktopNavigationGrid} ${s.lowerNavigation}`} ref={refWrapper}>
      {windowSize.width && <>
        <a href={homeURL} className={s.desktopNavigationGrid__logo}>
          <AvionautLogo/>
        </a>
        <a href={carSeatsURL}
           className={`${s.desktopNavigationGrid__link} ${s.desktopNavigationGrid__products}`}
        >
          <span>{intl.formatMessage({ id: 'navbar__carSeats' })}</span>
        </a>
        <a href={`${carSeatsURL}/sirius`}
           className={`${s.desktopNavigationGrid__link} ${s.desktopNavigationGrid__other}`}
        >
          <span>{intl.formatMessage({ id: 'hpProducts__strollers_title' })}</span>
        </a>
        {localeHelper.knowledgeBaseLocalesArray.includes(intl.locale) &&
          <a href={kbURL}
             className={`${s.desktopNavigationGrid__link} ${s.desktopNavigationGrid__shops}`}
          >
            <span>{intl.formatMessage({ id: 'navbar__knowledgeBase' })}</span>
          </a>
        }
        <a href={contactURL}
           className={`${s.desktopNavigationGrid__link} ${s.desktopNavigationGrid__contact}`}
        >
          <span>{intl.formatMessage({ id: 'navbar__contact' })}</span>
        </a>
        <div className={s.desktopNavigationGrid__shop}>
          {
            (intl.locale === 'fr' || intl.locale === 'pl' || intl.locale === 'de') &&
            <a href={ShopOnlineURL[intl.locale]} target={'_blank'}
               className={`${s.desktopNavigationGrid__button}`}
            >
              <Shop className={s.desktopNavigationGrid__shopico}/>
              {intl.formatMessage({ id: 'navbar__shopOnline' })}
            </a>
          }
        </div>
        <div className={s.desktopNavigationGrid__switch}>
          <Switch
            multilingualSlugsForStaticPages={multilingualSlugsForStaticPages}
            multilingualSlugsForCmsArticle={multilingualSlugsForCmsArticle}
            currentLocale={intl.locale}
            isKnowledgeBase={isKnowledgeBase}
            pageType={pageType}
          />
        </div>
      </>
      }
    </div>
  );
};

export default DesktopNavigationGrid;
